import "./Modal.css";
import { memo, useContext, useEffect, } from "react";
import { BefPageContainerServiceProvider, BefPageControllerContext, } from "@beflam/bef-core";
import { Dialog, } from "@alifd/next";
import React from "react";
import { PageContainer } from "./PageContainer";
import { isNumber } from "lodash";

export function containderInner(props: { dialog: any }) {
    const dialog = props.dialog;
    return (
        <BefPageContainerServiceProvider key={dialog.id}>
            <PageContainer key={dialog.id} container={dialog} />
        </BefPageContainerServiceProvider>
    );
}

const MemoContainer = memo(containderInner, (prevProps, nextProps) => prevProps.dialog.id === nextProps.dialog.id);
export function BefDialog(props: any) {
    let [dialog, setDialog] = React.useState<any>(props.dialog)
    let [visible, setVisible] = React.useState<any>(props.visible)
    const [modalOption, setModalOption] = React.useState<{ width?: number | string, height?: number | string, isFull: boolean }>
        ({ width: dialog?.activePage?.width || 870, height: dialog?.activePage?.height || 600, isFull: false });
    const supportFullScreen = dialog.supportFullScreen;

    // let befLanguageService = useContext(BefLanguageServiceContext);
    // let globalService = useContext(BefGlobalContext);
    // let messageController = useContext(BefMessageControllerServiceContext);
    let pageController = useContext(BefPageControllerContext);

    useEffect(() => {

    }, []);

    const onClose = () => {
        setVisible(false)
        pageController.close(dialog);
        // setDialog(null);

    }

    const modalFull = () => {
        if (modalOption.isFull) {
            setModalOption({ ...modalOption, isFull: false, width: dialog?.activePage?.width || 870, height: dialog?.activePage?.height || 600 });
        } else {
            setModalOption({ ...modalOption, isFull: true, width: '100%', height: `${(window.innerHeight ?? 959) - 2}px` });
        }
    };
    return (
        <>
            <Dialog
                v2
                title={
                    <>{dialog.title}
                        {supportFullScreen && <span className='bef-big-modal-header-icon' style={{ float: 'right' }} onClick={() => modalFull()}>
                            <i>{modalOption.isFull ?
                                <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M881.7 187.4l-45.1-45.1a8.03 8.03 0 00-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L447.9 585a7.9 7.9 0 00-8.9-8.9z" />
                                </svg> :
                                <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" />
                                </svg>
                            }</i>
                        </span>}
                    </>}
                visible={visible}
                footer={false}
                onOk={onClose}
                height={modalOption.height}
                width={modalOption.width}
                onClose={onClose}
                overflowScroll
                wrapperClassName={supportFullScreen ? "bef-dialog" : undefined}
                centered={supportFullScreen}
                top={supportFullScreen ? 1 : undefined}
                bottom={supportFullScreen ? 1 : undefined}
            >
                <div style={{ "position": "relative", height: `calc(${isNumber(modalOption.height) ? `${modalOption.height}px` : modalOption.height} - 85px)` }}>
                    <MemoContainer dialog={dialog}></MemoContainer>
                </div>
            </Dialog>
        </>
    )
}